export interface GooglePaySdkPaymentData {
  apiVersion: number,
  apiVersionMinor: number,
  paymentMethodData: GooglePayTokenPaymentMethodData
}

export interface GooglePayTokenPaymentMethodData {
  description: string,
  type: string,
  info: GooglePayTokenPaymentMethodDataInfo,
  tokenizationData: GooglePayTokenPaymentMethodTokenizationData
}

export interface GooglePayTokenPaymentMethodDataInfo {
  assuranceDetails: GooglePayTokenPaymentMethodDataAssuranceDetails,
  cardDetails: string,
  cardNetwork: string
}

export interface GooglePayTokenPaymentMethodDataAssuranceDetails {
  accountVerified: boolean,
  cardHolderAuthenticated: boolean
}

export interface GooglePayTokenPaymentMethodTokenizationData {
  token: string,
  type: string
}


export function isGooglePaySdkPaymentData(obj: any): obj is GooglePaySdkPaymentData {
  return obj?.paymentMethodData?.tokenizationData?.token !== undefined
}